export default __webpack_public_path__ + "static/media/plano-1.0be96bdd.png";